<script lang="ts">
	import { _ } from 'svelte-i18n';
	import RangeDatePicker from '$lib/components/DatePicker/RangeDatePicker.svelte';
	import PerformanceHeader from '$lib/components/headerBar/performance/PerformanceHeader.svelte';
	import HubTable from './tables/HubTable.svelte';
	import PostTable from './tables/PostTable.svelte';
	import UserMetrics from '$lib/components/headerBar/performance/tables/UserMetrics.svelte';
	import type { HeaderTitles } from '$lib/types/HeaderTitles';

	import type { Post } from '$lib/api/rpc';
	import { onMount } from 'svelte';

	let selected = {
		start: undefined,
		end: undefined,
	};

	let header: HeaderTitles[] = [
		{
			navigation: $_('performance.hub.metrics'),
			title: $_('performance.all.posts'),
			subtitle: '',
			status: '',
		},
	];
	$: currentPage = header[header.length - 1];

	export let post: Post | undefined = undefined;

	onMount(() => {
		if (post != undefined || post != null) {
			const postPage: HeaderTitles = {
				navigation: $_('performance.post.metrics'),
				title: post.title ?? $_('performance.untitled'),
				subtitle: post.meta_title ?? '',
				id: post.id,
				status: post.status,
			};
			header = [...header, postPage];
		}
	});
	/* eslint-disable @typescript-eslint/restrict-plus-operands */
</script>

<div class="container">
	<PerformanceHeader
		{header}
		changePage={(i) => {
			header = header.splice(0, i + 1);
		}} />
	{#if header.length === 1}
		<div class="datePickerRow">
			<RangeDatePicker bind:startDate={selected.start} bind:endDate={selected.end} />
		</div>
	{/if}
	<div>
		{#if currentPage.navigation === $_('performance.hub.metrics')}
			<HubTable
				selectedDate={selected}
				callback={(title, subtitle, id, status) => {
					header = [
						...header,
						{
							navigation: $_('performance.post.metrics'),
							title: title,
							subtitle: subtitle,
							id: id,
							status: status,
						},
					];
				}} />
		{:else if currentPage.navigation === $_('performance.post.metrics')}
			<PostTable
				id={currentPage.id || ''}
				published={currentPage.status === 'published'}
				callback={(title, subtitle, id) => {
					header = [
						...header,
						{
							navigation: $_('performance.user.metrics'),
							title: title,
							pretitle: header[1].title,
							subtitle: subtitle,
							id: id,
							status: currentPage.status,
						},
					];
				}} />
		{:else if currentPage.navigation === $_('performance.user.metrics')}
			<UserMetrics
				published={currentPage.status === 'published'}
				postId={header[1].id || ''}
				userId={currentPage.id || ''} />
		{/if}
	</div>
</div>

<style>
	.container {
		display: flex;
		flex-direction: column;
		align-self: flex-start;
		inline-size: 100%;
	}

	.datePickerRow {
		display: flex;
		align-self: flex-end;
	}
</style>
